export const environment = {
  production: true,
  analyticsKey: 'UA-78684294-66',
  envAPI: 'REST_API_URL',
  type: 'production',
  appVersion: 'APP_PRODUCT_VERSION',
  maintenanceMode: 'MAINTENANCE_MODE',
  sentryDsn: 'https://64f883edcdc747e0a80f74c38a75cbeb@o1076764.ingest.sentry.io/4504287488180224'
};
